module.exports = __webpack_public_path__ + "img/dropbox.fd841674.png";